import { Search } from 'iconoir-react';
import { useContext, useState } from 'react';
import { SearchContext } from '../contexts/SearchContext';
import { useNavigate } from "react-router-dom";

export function SearchBar() {
  const { setWord } = useContext(SearchContext);
  const [searchQuery, setSearchQuery] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const searchQueryTrimmed = searchQuery?.trim();
    if (searchQueryTrimmed) {
      setWord(searchQueryTrimmed);
      navigate(`/?search=${searchQuery}`);
    }
  }

  const handleBlur = () => {
    setIsTouched(true);
  }

  return (
    <form onSubmit={handleSearch}>
      <div className="flex items-center space-x-2 mt-4 relative">
        <input
          className={`w-full bg-dark-700 dark:bg-dark-300 font-medium rounded-md py-2 px-4 focus:outline-none ring-2  ${isTouched && !searchQuery ? 'ring-red-500' : 'ring-transparent'} focus:ring-brand-purple focus:border-transparent`}
          placeholder="Search for any word..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onBlur={handleBlur}
        />
        <button className="absolute right-2 px-3 py-2 hover:bg-brand-purple-dark focus:outline-none">
          <Search
            height={20}
            width={20}
            className="stroke-2 text-brand-purple"
          />
        </button>
      </div>
      
      <p className="text-red-500 text-sm h-1 mt-1">{isTouched && !searchQuery && "Whoops, can't be empty..."}</p>
    </form>
  );
}
